import React from "react";
import MenuButton from "../Button/MenuButton";
import JDPCustomButton1 from "../Button/JDPCustomButton1";
import JDPACustomButton2 from "../Button/JDPACustomButton2";
import LanguagePanel from "../Button/LanguagePanel";
import './Header.scss';
import { useSelector } from "react-redux";
import {
    exterirorColorCode,
    secondaryVehiclesTrims,
    setActiveLocale,
    setDefaultLanguage,
    setSupportedLanguages,
    setHeaderLoadType
} from "../../slices/vehicleSlice";
import useMediaQuery from '@mui/material/useMediaQuery';
import ExpandableJDPACustomButton1 from "../Button/ExpandableJDPACustomButton1";
import ExpandableJDPACustomButton2 from "../Button/ExpandableJDPACustomButton2";
import ExpandableMenuButton from "../Button/ExpandableMenuButton";
import MobileNavMenu from "../Button/MobileNavMenu";
import {Toolbar} from "@mui/material";

const Header = () => {
    const getSupportedLanguages = useSelector(setSupportedLanguages);
    const getDefaultLanguage = useSelector(setDefaultLanguage);
    const vehicleCodes = useSelector(secondaryVehiclesTrims);
    const locale = useSelector(setActiveLocale);
    const exteriorColor = useSelector(exterirorColorCode);
    const headerLoadType = useSelector(setHeaderLoadType);
    const [openMenu, setOpenMenu] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const jdpaCTA2Titles = ["EV Learning Center", "Best Cars and Trucks by Ratings", "Award Winners", "VIN Lookup", "Compare Cars", "Research by Make"];
    const jdpaCTA2Links = [
        "https://www.jdpower.com/electric-vehicles",
        "https://www.jdpower.com/cars/rankings",
        "https://www.jdpower.com/cars/ratings",
        "https://www.jdpower.com/cars/vin-lookup-and-decoder",
        "https://www.jdpower.com/cars/compare-cars",
        "https://www.jdpower.com/cars"
    ];
    const jdpaCTA3Titles = ["United States", "Canada", "China", "Europe", "Japan", "Mexico", "Careers"];
    const jdpaCTA3Links = [
        "https://www.jdpower.com/business?utm_source=Consumer&utm_medium=Link&utm_campaign=jdp_consumer",
        "https://canada.jdpower.com/?utm_source=Consumer&utm_medium=Link&utm_campaign=jdp_consumer",
        "https://china.jdpower.com/?utm_source=Consumer&utm_medium=Link&utm_campaign=jdp_consumer",
        "https://autovista.com",
        "https://japan.jdpower.com/ja",
        "https://mexico.jdpower.com/?utm_source=Consumer&utm_medium=Link&utm_campaign=jdp_consumer",
        "https://www.jdpower.com/business/careers"];
    const setDefaultLng = (locale) => locale;
    const isMobile = useMediaQuery('(max-width: 768px)');

    const handleSmallMenuClick = (menuName) => {
        setOpenMenu(openMenu === menuName ? null : menuName);
    };

    const handleDesktopMenuOpen = (event) => {
        setAnchorEl({target: event.currentTarget, id: event.id});
    };

    const handleDesktopMenuClose = () => {
        setAnchorEl(null)
    };

    return (
        <div className={'header-main'}>
            { headerLoadType != null ? (
                <div className="header-jdpa">
                    <Toolbar className={'header-jdpa-container'}>
                        <div className="logo"
                             onClick={() => window.open('https://www.jdpower.com/consumer-resources', '_self')}
                        />
                        <MobileNavMenu isMobile={isMobile}>
                            <div className={'header-menu'}>
                                {isMobile ? (
                                    <>
                                        <div className="menu-category-border">
                                            <ExpandableJDPACustomButton1
                                                open={openMenu === 'Vehicles for Sale'}
                                                onClick={() => handleSmallMenuClick('Vehicles for Sale')}
                                            />
                                        </div>
                                        <div className="menu-category-border">
                                            <ExpandableJDPACustomButton2
                                                open={openMenu === 'Pricing & Values'}
                                                onClick={() => handleSmallMenuClick('Pricing & Values')}
                                            />
                                        </div>
                                        <ExpandableMenuButton
                                            name={'Research'}
                                            titles={jdpaCTA2Titles}
                                            links={jdpaCTA2Links}
                                            open={openMenu === 'Research'}
                                            onClick={() => handleSmallMenuClick('Research')}
                                        />
                                        <ExpandableMenuButton
                                            name={'Business'}
                                            titles={jdpaCTA3Titles}
                                            links={jdpaCTA3Links}
                                            open={openMenu === 'Business'}
                                            onClick={() => handleSmallMenuClick('Business')}
                                        />
                                    </>
                                )  : (
                                    <>
                                        <JDPCustomButton1
                                            anchorEl={anchorEl?.target}
                                            setAnchorEl={setAnchorEl}
                                            open={anchorEl?.id === 'Vehicles for Sale'}
                                            handleMenuOpen={(event) => handleDesktopMenuOpen({ ...event, id: 'Vehicles for Sale' })}
                                            handleMenuClose={handleDesktopMenuClose}
                                        />
                                        <JDPACustomButton2
                                            anchorEl={anchorEl?.target}
                                            setAnchorEl={setAnchorEl}
                                            open={anchorEl?.id === 'Pricing & Values'}
                                            handleMenuOpen={(event) => handleDesktopMenuOpen({ ...event, id: 'Pricing & Values' })}
                                            handleMenuClose={handleDesktopMenuClose}
                                        />
                                        <MenuButton
                                            name={'Research'}
                                            titles={jdpaCTA2Titles}
                                            links={jdpaCTA2Links}
                                            leftShift={178}
                                            anchorEl={anchorEl?.target}
                                            setAnchorEl={setAnchorEl}
                                            open={anchorEl?.id === 'Research'}
                                            handleMenuOpen={(event) => handleDesktopMenuOpen({ ...event, id: 'Research' })}
                                            handleMenuClose={handleDesktopMenuClose}
                                            onClick={() => handleDesktopMenuOpen({id:'Research'})}
                                        />
                                        <MenuButton
                                            name={'Business'}
                                            titles={jdpaCTA3Titles}
                                            links={jdpaCTA3Links}
                                            leftShift={24}
                                            anchorEl={anchorEl?.target}
                                            setAnchorEl={setAnchorEl}
                                            open={anchorEl?.id === 'Business'}
                                            handleMenuOpen={(event) => handleDesktopMenuOpen({ ...event, id: 'Business' })}
                                            handleMenuClose={handleDesktopMenuClose}
                                        />
                                    </>
                                )}
                            </div>
                        </MobileNavMenu>
                    </Toolbar>
                    <div className={'gradient-line'} />
                </div>
            ) : (
                <div className={'header-default'}>
                    <div className={'header-default-container'}>
                        <div className="header">
                            <div className={'header-container'}>
                                <div className="logo"/>
                                <div className="languageSelectionTab">
                                    <LanguagePanel
                                        getDefaultLanguage={getDefaultLanguage}
                                        getSupportedLanguages={getSupportedLanguages}
                                        setDefaultLng={setDefaultLng}
                                        activeLocale={locale}
                                        vehicleCodes= {vehicleCodes}
                                        exterirorColorCode = {exteriorColor}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Header;